import { createSelector } from 'reselect';
import { updateBIAButtonTreatmentSelector } from 'selectors/testTarget/offers/updateBIAButtonTreatment/updateBIAButtonTreatmentSelector';

const experienceSelector = createSelector(updateBIAButtonTreatmentSelector, updateBIAButtonTreatment => updateBIAButtonTreatment.experience);

export { experienceSelector };
